export enum DestinationAction {
    Prepare = 'prepare',
    ImportStats = 'import-stats',
    InProgressStats = 'in-progress-stats',
    Import = 'import',
    Download = 'download',
}
